import { successMessage } from "@constants/errSuccConstant";
import dayjs from "dayjs";

export const deathNotificationForm = {
    dateOfDeath: {
        '#type': 'date',
        '#title': 'Date Of Death',
        '#webform_key': 'dateOfDeath',
        '#required': true,
        '#maxDate': dayjs(new Date()).format('YYYY-MM-DD'),
    },
    timeOfDeath: {
        '#type': 'time',
        '#title': 'Time Of Death',
        '#webform_key': 'timeOfDeath',
        '#required': true,
      },
      comment: {
        '#type': 'textfield',
        '#title': 'Comment',
        '#webform_key': 'comment',
        '#required': false,
      },
  };
  
  export const deathNotificationFormState: any = {
    dateOfDeath: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    timeOfDeath: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    comment: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
  };

  export const messages: any = {
    errorMessage: 'An error occurred while processing the request.',
    commentErrorMessage: 'Comment cannot exceed 100 words.',
    successMessage:'Death Reported to ANM'
  };

  export const modalContent: any = {
    headerText: 'Notify Death',
    bodyText: "Are you sure you want to notify beneficiary's death to ANM"
  }